import {select} from '@angular-redux/store';
import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {ActivatedRoute, NavigationEnd, Params, Router} from '@angular/router';
import {SubNav} from '@core/models/sub-nav.model';
import * as Store from '@core/redux/stores';
import {LocationsEntity} from '@core/redux/stores';
import {
  AuthenticationService,
  ChatService,
  ConfirmModalService,
  CookieManagerService,
  DetectBrowser,
  GetOrderService,
  LocationCoreService,
  ModalService,
  SubNavService,
} from '@core/services';
import {EmergencyBannerComponent} from '@features/home/emergency-banner/emergency-banner.component';
import {Observable, Subscription} from 'rxjs';

import {ENTRYCOMPONENTSMAP} from '@core/models/component-map.model';
import {RewardService} from '@features/rewards/services/reward.service';
import {Constants} from '@app/core/constants/core.constants';
import {SurveyService} from '@core/services/survey.service';
import { filter } from 'rxjs/operators';

export type Position = 'end' | 'start';

@Component({
  moduleId: module.id,
  selector: 'app-landing',
  templateUrl: './app-landing.component.html',
  styleUrls: ['../styles/app-root.styles.less']
})
export class LandingComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('containerContent', {static: true}) containerContent: ElementRef;
  @ViewChild('mainContent', {static: true}) mainContent: ElementRef;
  @ViewChild('flyoutbody', {read: ViewContainerRef, static: true}) ref: ViewContainerRef;
  @ViewChild('sidenav', {static: true}) sidenav: MatSidenav;
  @ViewChild(EmergencyBannerComponent, {static: false})
  emergencyBanner: EmergencyBannerComponent;
  @ViewChild('locationBanner', {read: ElementRef}) locationBanner: ElementRef;


  @select(appState => appState.contactUs) contactDetails?: Observable<
    Store.ContactUs
  >;
  @select((appState) => appState.locationSelected) locationSelected: Observable<LocationsEntity>;
  @select(appState => appState.activeOrder) activeOrder: Observable<Store.Order>;
  @select(appState => appState.user) user: Observable<Store.User>;

  private orderingHeaderUrls = [
    'ordering',
    'editfavoriteorder',
    'favorite',
    'order',
    'menu',
    'locations',
    'reward',
    'customization',
    'order-review',
    'rewards',
    'nonfood'
  ];

  private rewardBannerExceptions = [
    'customization'
  ]
  private orderingHeaderExceptions = [
    '/contact-us',
    '/contact-us/thanks',
    '/ordering/orderstatus',
    '/ordering/viewreceipt',
    '/rewards/what-can-i-earn'
  ];

  private noCartUrls = [
    '/ordering/confirm-and-pay',
    '/ordering/changeinfo',
    '/ordering/checkout/payment',
    '/ordering/checkout',
    '/ordering/checkout/customer-info',
    '/order-review',
  ];

  // the component body
  private compBody: any;
  private compRef: ComponentRef<any>;
  private compName: string;
  private compSelector: string;

  private subscriptions = new Subscription();
  private routeSub = new Subscription();

  private visible: boolean;
  public isOrdering: boolean;
  public showCart: boolean;
  encapsulation: ViewEncapsulation.None;
  private scrollToTop: boolean;
  public isConfirmAndPay: boolean;
  public isContactSummary: boolean;
  public isEmergencyBanner: boolean;
  public isRewards: boolean;
  public isSubNavPresent: boolean;
  public isContactObjEmpty: boolean;
  contactDetailsData: Store.ContactUs;
  private location: Store.LocationsEntity;
  isFullMenuLoaded = false;
  isDeliveryAddressLoaded = false;
  public pos: Position;
  automaticDeliveryLocation = false;
  points: any;
  isGame: boolean;
  private userObj: Store.User;
  private cfr = inject(ComponentFactoryResolver);
  private modalService = inject(ModalService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private confirmModalService = inject(ConfirmModalService);
  private authenticationService = inject(AuthenticationService);
  private subNavService = inject(SubNavService);
  private locationCoreService = inject(LocationCoreService);
  private orderService = inject(GetOrderService);
  private detectBrowserService = inject(DetectBrowser);
  private rewards = inject(RewardService);
  private chat = inject(ChatService);
  private cookieManager = inject(CookieManagerService);
  private survey = inject(SurveyService);

  constructor() {
    this.visible = false;
    this.isOrdering = false;
    this.isEmergencyBanner = false;
    this.showCart = false;
    this.scrollToTop = false;
    this.isSubNavPresent = false;
    this.isRewards = false;
    this.subscriptions.add(
      this.locationCoreService.isMenuLoaded$.subscribe(status =>
        setTimeout(() => this.isFullMenuLoaded = status, 100)));
    this.subscriptions.add(
      this.orderService.isDeliveryAddressLoaded$.subscribe(status =>
        setTimeout(() => this.isDeliveryAddressLoaded = status, 100)));
    this.subscriptions.add(
      this.locationSelected.subscribe(
        (location) => {
          this.location = location;
        }
      )
    );
    this.subscriptions.add(
      this.activeOrder.subscribe(
        (order) => {
          this.automaticDeliveryLocation = order?.automaticDeliveryLocation;
        }
      )
    );
    this.subscriptions.add(
      this.user.subscribe(
        (user) => {
          this.userObj = user;
          if (this.userObj) {
            if (typeof window.QSI === 'undefined') {
              window.QSI = {};
            }
            window.QSI.config = {
              externalReference: this.userObj?.id
            };
            if (!this.survey.isQualtricsLoaded) {
              this.survey.loadScript().subscribe((value) => {
                this.survey.isQualtricsLoaded = true;
              });
            }
          }
        }
      )
    );
    this.pos = 'end' as Position;
    if (this.detectBrowserService.isIEAndNotEdge()) {
      this.pos = 'start' as Position;
    }
    this.isGame = false;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.chat.startChat = event?.url?.toLowerCase()?.includes(Constants.START_CHAT);
      this.chat.checkRouteAndHideChat();
    });

  }

  ngOnInit() {
    this.chat.loadSDK();
    this.subscriptions.add(
      this.activatedRoute.url.subscribe(url => {
        this.checkUrl(url[0].toString());
        this.cookieManager.reloadOTBanner();
      })
    );
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTopPage();
      }
    });
    this.subscriptions.add(
      this.confirmModalService.btnEvent.subscribe(async (data: string) => {
        if (data === 'resendConfirmation') {
          this.authenticationService.resendConfirmation();
        } else if (data === 'cancelBtn') {
          this.router.navigate(['/account']);
        }
      })
    );
    this.subscriptions.add(
      this.subNavService.getSubNavOut.subscribe((data: SubNav[]) => {
        if (data && data.length > 0) {
          this.isSubNavPresent = true;
        }
      })
    );
  }

  // loadQualtrics() {
  //   return this.scriptLoader.load({id: 'qualtrics-wb', src: '/assets/js/qualtrics.js', loaded: false});
  // }
  scrollToTopPage() {
    setTimeout(() => {
      const element = document.querySelector('#mainContent');
      if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    }, 100);
  }

  hideEmergencyBanner() {
    this.isEmergencyBanner = false;
  }

  checkUrl(url: string) {
    const rUrl = this.router.url.toString();
    const routerUrl = rUrl.split('?')[0];
    this.isConfirmAndPay = false;
    this.isContactSummary = false;
    if (routerUrl.includes('order-review')) {
      this.isContactSummary = true;
    } else if (routerUrl.includes('summary')) {
      this.isContactSummary = true;
    } else if (rUrl === '/home') {
      this.isEmergencyBanner = true;
    } else if (rUrl.includes('/rewards') && this.orderingHeaderExceptions.indexOf(routerUrl) < 0 && !this.rewardBannerExceptions.some(e => routerUrl.includes(e))) {
      this.isRewards = true;
      this.setUpRewardsBanner();
    } else if (rUrl.includes('/score-more')) {
      this.isGame = true;
    }

    // add fix for edit favorite ordering header. Working on genaralised solution of displaying header
    // TODO add order-review/final-checkout
    if (
      (this.orderingHeaderUrls.indexOf(url) > -1 &&
        this.orderingHeaderExceptions.indexOf(routerUrl) < 0) ||
      rUrl.indexOf('editfavoriteorder') !== -1
    ) {
      this.isOrdering = true;
    } else {
      this.isOrdering = false;
    }
    this.setOrderLandingFooterStyles(this.isOrdering);

    // this.showCart = (this.noCartUrls.indexOf(routerUrl) < 0);

    const isChPt = routerUrl.indexOf('ordering/checkout/payment');
    const isContactLocation = rUrl.indexOf('contact-us');
    this.showCart =
      this.noCartUrls.indexOf(routerUrl) < 0 &&
      isChPt < 0 &&
      isContactLocation < 0;
    if (this.location && this.location.isAssumedLocation) {
      this.showCart = false;
    }
    if (url.indexOf('#') < 0) {
      this.scrollToTop = true;
    }
  }

  setUpRewardsBanner() {
    if (this.rewards.points == undefined || this.rewards.points == null) {
      this.rewards.getRewardSummary().then(
        success => {
          this.points = success.points;
        }
      ).catch(error => console.log(error));
    }
  }

  ngAfterViewInit() {
    this.modalService.setFlyoutModal(this);
    this.setBodyComponent();
    this.sidenav.disableClose = true;
    this.routeSub = this.activatedRoute.fragment.subscribe(frag => {
      setTimeout(() => {
        this.scrollElement(frag);
      }, 100);
    });

    this.routeSub.unsubscribe();
    this.subscriptions.add(
      this.activatedRoute.queryParams.subscribe((params: Params) => {
        const verify = Boolean(params[Constants.VERIFY_EMAIL] as string);
        if (verify) {
          setTimeout(() => {
            this.confirmModalService.show(
              'Your account needs email validation',
              '',
              'Your email address is not yet authenticated. We can resend the authentication email.',
              'Resend Email',
              '',
              'Cancel',
              true,
              'resendConfirmation',
              '',
              'cancelBtn'
            );
          }, 1000);
        }
        const appleSignInOrigin = params[Constants.APPLE_SIGNIN_ORIGIN] as string;
        this.showAppleSignInComponent(appleSignInOrigin);
      })
    );
  }

  private showAppleSignInComponent(appleSignInOrigin: string) {
    if (appleSignInOrigin) {
      if (appleSignInOrigin?.toLowerCase() === Constants.SIGNIN) {
        this.showModal(this.modalService.getSignInModalSelector());
      } else if (appleSignInOrigin?.toLowerCase() === 'register') {
        this.showModal(this.modalService.getSignupModalSelector());
      }
    }
  }

  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  setOrderLandingFooterStyles(isOrderLanding: boolean) {
    // set content based on header height. Height varies when order component loads
    if (isOrderLanding) {
      let element = this.containerContent.nativeElement as HTMLElement;
      element.classList.add('container-ordering');
      element = this.mainContent.nativeElement as HTMLElement;
      element.classList.add('order-content');
    } else {
      let element = this.containerContent.nativeElement as HTMLElement;
      element.classList.remove('container-ordering');
      element = this.mainContent.nativeElement as HTMLElement;
      element.classList.remove('order-content');
    }
  }

  scrollElement(frag: string) {
    const element = document.querySelector('#' + frag);
    if (element) {
      element.scrollIntoView();
    }
  }

  private setBodyComponent() {
    if (this.compName && this.compName !== null && this.compName !== '') {
      this.compBody = this.compName;
    } else if (
      this.compSelector &&
      this.compSelector !== null &&
      this.compSelector !== ''
    ) {
      this.compBody = this.compSelector;
    }
  }

  private loadComponent() {
    const componentFactory = this.cfr.resolveComponentFactory(ENTRYCOMPONENTSMAP[this.compBody]);
    this.compRef = this.ref.createComponent(componentFactory);
    this.compRef.changeDetectorRef.detectChanges();
  }

  public setCompName(compName: string) {
    this.compName = compName;
    this.setBodyComponent();
  }

  public setCompSelector(compSelector: string) {
    this.compSelector = compSelector;
    this.setBodyComponent();
  }

  public toggle(action: string) {
    this.visible = !this.visible;

    if (action === 'open') {
      this.visible = true;
    } else if (action === 'close') {
      this.visible = false;
    }

    if (this.visible) {
      if (this.compBody !== null && typeof this.compBody !== 'undefined') {
        this.loadComponent();
        this.sidenav.open();
      }
    } else {
      this.sidenav.close();
      setTimeout(() => {
        this.ref.clear();
        this.ref.detach();
      }, 300);
    }
  }

  public onViewPort({target, visible}: { target: Element; visible: boolean }): void {
    if (this.locationBanner) {
      this.locationBanner.nativeElement.className = visible ? 'banner-anchored' : 'banner-sticky';
    }
  }
}
